import { ApiClient } from "#/shared/api/client";
import { InsurancePlan } from "#ce/apps/shared/filters/insurance-plan/models/insurance-plan";

export const INSURANCE_FILTER_DEFAULT_BASE_URL = "/physicians/filters?sections=insurance_plans";
export const INSURANCE_FILTER_DEFAULT_API = "provider_search";

export class InsuranceFilterApi extends ApiClient {
  constructor(options) {
    super({ ...options, model: InsurancePlan });
  }

  transform(responseData) {
    if (!responseData) {
      return null;
    }

    const { meta, data } = responseData;
    return {
      meta,
      data: super.transform(data),
    };
  }
}

export const createInsuranceFilterApi = ({
  api = INSURANCE_FILTER_DEFAULT_API,
  baseUrl = INSURANCE_FILTER_DEFAULT_BASE_URL,
  url,
} = {}) => {
  const options = {};

  // If a URL is provided, use it as the base URL.
  // This is useful for dedicated endpoints such as provider insurance plans.
  if (url) {
    options.baseURL = url;
  } else {
    options.baseURL = baseUrl;
    options.api = api;
  }

  const instance = new InsuranceFilterApi(options);

  return {
    all: async () => instance.get(""),
  };
};
